var map = {
	"./base/Box.vue": 5006,
	"./base/Button.vue": 4652,
	"./base/Col.vue": 4808,
	"./base/Container.vue": 1249,
	"./base/Image.vue": 4244,
	"./base/Images.vue": 3715,
	"./base/Link.vue": 8777,
	"./base/Links.vue": 6306,
	"./base/List.vue": 5700,
	"./base/Row.vue": 2960,
	"./base/Sections.vue": 7279,
	"./base/Segment.vue": 8679,
	"./base/Slide.vue": 4612,
	"./base/Spinner.vue": 2167,
	"./base/Svg.vue": 6237,
	"./base/Text.vue": 2977,
	"./base/Video.vue": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2003;